import type { TimeSpeedInputs } from "./types";

export const defaultTimeSpeedInputs: TimeSpeedInputs = {
  weldLength: 100,
  duration: 85.7,
  travelSpeed: 40
};
